import React, { useEffect, useState, useCallback } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
} from "@mui/material";
import { toast } from "react-toastify";
import moment from "moment";
import {
  Close,
  RemoveRedEyeOutlined,
  Download as DownloadIcon,
} from "@mui/icons-material";
import Axios from "../axios";
import { CSVLink } from "react-csv";
import "react-quill/dist/quill.snow.css";
import { Helmet } from "react-helmet";

const ArrivalsList = () => {
  const [allArrivals, setAllArrivals] = useState([]);
  const [pagination, setPagination] = useState({
    page: 0,
    count: 0,
    search: "",
  });
  const [downloadData, setDownloadData] = useState([]);
  const [dialogState, setDialogState] = useState({
    open: false,
  });
  const [viewData, setViewData] = useState(null);
  const headers = [
    { label: "Booking ID", key: "bookingID" },
    { label: "Booking Date", key: "bookingDate" },
    { label: "Check in date", key: "tripStartDate" },
    { label: "Checkout date", key: "tripEndDate" },
    { label: "Customer email", key: "email" },
    { label: "Guest Name", key: "guestNames" },
    { label: "Room Count", key: "roomsCount" },
    { label: "Nights", key: "nights" },
    { label: "Room Nights", key: "nights" },
    { label: "Room type booked", key: "rooms" },
    { label: "Value adds included", key: "valueAddedService" },
    { label: "Sell Rate(USD)", key: "sellRate" },
    { label: "Net Rate(USD)", key: "netRate" },
    { label: "Hotel Confirmation", key: "hotelConfirmation" },
    { label: "Supplier Property ID", key: "supplierPropertyID" },
    { label: "Property ID", key: "propertyID" },
    { label: "Property Name", key: "propertyName" },
    { label: "Property Address", key: "propertyAddress" },
    { label: "Property Region", key: "propertyRegion" },
    { label: "Property star rating", key: "propertyStarRating" },
    { label: "Adults", key: "adults" },
    { label: "Children", key: "children" },
  ];
  const fetchArrivals = useCallback((page = 0, search = "") => {
    const data = { page, searchChar: search };

    Axios.post(`${process.env.REACT_APP_BACKEND}get-all-arrivalList`, data)
      .then((resp) => {
        setAllArrivals(resp?.data?.data?.data);
        setPagination((prev) => ({
          ...prev,
          count: resp?.data?.data?.totalCount || 0,
          page,
          search,
        }));
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Failed to fetch arrivals");
      });
  }, []);
  const fetchDownloadData = useCallback(() => {
    Axios.post(`${process.env.REACT_APP_BACKEND}get-all-csv-data`)
      .then((resp) => {
        setDownloadData(resp?.data?.data || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Failed to fetch download data"
        );
      });
  }, []);
  useEffect(() => {
    fetchArrivals();
    fetchDownloadData();
  }, [fetchArrivals, fetchDownloadData]);
  const handleOpen = (data) => {
    setViewData(data);

    setDialogState({ open: true });
  };
  const handleClose = () => {
    setDialogState({ open: false });
    setViewData(null);
  };

  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    rowsPerPageOptions: [],
    serverSide: true,
    count: pagination.count,
    page: pagination.page,
    download: false,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchArrivals(tableState.page, pagination.search);
      }
    },
    onSearchChange: (searchText) => {
      fetchArrivals(pagination.page, searchText);
    },
    customToolbar: () => (
      <Tooltip title="Download">
        <IconButton>
          <CSVLink
            data={downloadData}
            headers={headers}
            filename="arrivalList.csv"
          >
            <DownloadIcon className="downLoadCSVIcon" />
          </CSVLink>
        </IconButton>
      </Tooltip>
    ),
  };
  const columns = [
    {
      name: "bookingID",
      label: "Booking ID",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <p>{allArrivals[dataIndex]?.sevenlyBookingId}</p>
        ),
      },
    },
    // {
    //   name: "bookingID",
    //   label: "Supplier Booking ID",
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRenderLite: (dataIndex) => (
    //       <p>{allArrivals[dataIndex]?.bookingId}</p>
    //     ),
    //   },
    // },
    {
      name: "bookingID",
      label: "Co-Relation ID",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <p>{allArrivals[dataIndex]?.cid}</p>
        ),
      },
    },
    {
      name: "bookingID",
      label: "ZH ID",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <p>{allArrivals[dataIndex]?.internalRoomBookingId}</p>
        ),
      },
    },
    {
      name: "creationDate",
      label: "Booking Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div>
            {allArrivals[dataIndex]?.createdAt &&
              allArrivals[dataIndex]?.createdAt.split("T")[0]}{" "}
            {allArrivals[dataIndex]?.createdAt &&
              allArrivals[dataIndex]?.createdAt
                .split("T")[1]
                .split(":")
                .slice(0, 2)
                .join(":")}
          </div>
        ),
      },
    },
    {
      name: "checkInDate",
      label: "Check in date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div>
            {allArrivals[dataIndex].checkIn &&
              allArrivals[dataIndex].checkIn.split("T")[0]}{" "}
            {allArrivals[dataIndex].checkIn &&
              allArrivals[dataIndex].checkIn
                .split("T")[1]
                .split(":")
                .slice(0, 2)
                .join(":")}{" "}
          </div>
        ),
      },
    },
    {
      name: "checkOutDate",
      label: "Checkout date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div>
            {allArrivals[dataIndex].checkOut &&
              allArrivals[dataIndex].checkOut.split("T")[0]}{" "}
            {allArrivals[dataIndex].checkOut &&
              allArrivals[dataIndex].checkOut
                .split("T")[1]
                .split(":")
                .slice(0, 2)
                .join(":")}{" "}
          </div>
        ),
      },
    },
    // {
    //   name: "customerEmail",
    //   label: "Customer email",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRenderLite: (dataIndex) => (
    //       <p>{allArrivals[dataIndex]?.billingContact?.contact?.email}</p>
    //     ),
    //   },
    // },
    {
      name: "roomCount",
      label: "Room Count",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div>{allArrivals[dataIndex]?.reqOccupancies?.rooms}</div>
        ),
      },
    },
    {
      name: "nights",
      label: "Nights",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const tripEndDate = moment(allArrivals[dataIndex].checkOut);
          const tripStartDate = moment(allArrivals[dataIndex].checkIn);
          const nights = tripEndDate.diff(tripStartDate, "days");
          return <div>{nights === 1 ? `${nights} day` : `${nights} days`}</div>;
        },
      },
    },
    {
      name: "sellRate",
      label: "Sell Rate(USD)",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <p>{allArrivals[dataIndex]?.taxresult?.amount_total / 100}</p>
        ),
      },
    },
    {
      name: "options",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <Tooltip title="View Details">
            <IconButton
              aria-label="View Arrival Details"
              onClick={() => handleOpen(allArrivals[dataIndex])}
            >
              <RemoveRedEyeOutlined className="icon-size" />
            </IconButton>
          </Tooltip>
        ),
      },
    },
  ];
  const renderDetailView = () => {
    if (!viewData) return null;

    return (
      <div className="viewDetials">
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex align-view-center justify-content-between">
              <p className="fs-16 fw-600 mb-4">
                Booking ID :
                <span className="fw-400 fs-14">
                  {" "}
                  {viewData?.sevenlyBookingId}
                </span>
              </p>
              <p className="fs-16 fw-600 mb-4">
                Booking Date :
                <span className="fw-400 fs-14 ms-1">
                  {viewData?.createdAt && viewData?.createdAt.split("T")[0]}{" "}
                  {viewData?.createdAt &&
                    viewData?.createdAt
                      .split("T")[1]
                      .split(":")
                      .slice(0, 2)
                      .join(":")}
                </span>
              </p>
            </div>
            <p className="fs-16 fw-600 mb-4">
              Hotel Name :
              <span className="fw-400 fs-14"> {viewData?.hotels?.name}</span>
            </p>
            <p className="fs-16 fw-600 mb-3">
              Hotel Address:
              <span className="fw-400 ms-2 fs-14">
                {" "}
                {viewData?.hotels?.contact?.address?.line1} -
                {viewData?.hotels?.contact?.address?.postalCode}
              </span>
            </p>
            <p className="fs-16 fw-600 mb-3">
              Hotel Contact Number :
              <span className="fw-500 fs-18">
                {" "}
                {viewData?.hotels?.contact?.phones.map((phone, i) => (
                  <span className="fs-14 fw-400" key={i}>
                    {phone}
                  </span>
                ))}
              </span>
            </p>
            <p className="fs-16 fw-600 mb-4">
              Room Type :
              <span className="fw-400 fs-14">
                {" "}
                {viewData?.roomsAndRates?.name}
              </span>
            </p>
            <div className="d-flex align-viewDatas-center" style={{ gap: 50 }}>
              <p className="fs-16 fw-600 mb-4">
                Check In Date :
                <span className="fw-400 fs-14">
                  {" "}
                  {viewData?.checkIn && viewData.checkIn.split("T")[0]}{" "}
                  {viewData?.checkIn &&
                    viewData.checkIn
                      .split("T")[1]
                      .split(":")
                      .slice(0, 2)
                      .join(":")}{" "}
                </span>
              </p>
              <p className="fs-16 fw-600 mb-4 ">
                Check out Date :
                <span className="fw-400 fs-14">
                  {" "}
                  {viewData?.checkOut && viewData.checkOut.split("T")[0]}{" "}
                  {viewData?.checkOut &&
                    viewData.checkOut
                      .split("T")[1]
                      .split(":")
                      .slice(0, 2)
                      .join(":")}{" "}
                </span>
              </p>
            </div>
            <div className="d-flex align-viewDatas-center" style={{ gap: 50 }}>
              <p className="fs-16 fw-600 mb-4">
                Total Rooms :
                <span className="fw-400 fs-18">
                  {" "}
                  {viewData?.reqOccupancies?.rooms}
                </span>
              </p>
              {viewData?.roomsAllocations &&
                viewData?.roomsAllocations.length !== 0 && (
                  <p className="fs-16 fw-600 mb-4">
                    Total Guests:
                    <span className="fw-400 fs-18">
                      {" "}
                      {viewData?.roomsAllocations.reduce(
                        (sum, room) => sum + room.guests.length,
                        0
                      )}
                    </span>
                  </p>
                )}
            </div>
            {viewData?.roomsAllocations &&
              viewData?.roomsAllocations.length !== 0 && (
                <p className="fs-16 fw-600 mb-4">
                  Guests List :
                  <span className="fw-400 fs-18">
                    {" "}
                    {viewData?.roomsAllocations.map((guest, i) => (
                      <div
                        key={i}
                        className="d-flex align-viewDatas-center f-wrap"
                        style={{ gap: 50 }}
                      >
                        <p>Room: {i + 1}</p>
                        {guest.guests.map((name, index) => (
                          <div>
                            <p className="fs-14" key={index}>
                              Name: {name.firstName} {name.lastName}
                            </p>
                            <p className="fs-14" key={index}>
                              Email: {name.email}
                            </p>
                          </div>
                        ))}
                      </div>
                    ))}
                  </span>
                </p>
              )}

            <p className="fs-16 fw-600 mb-4">
              Refundability :
              <span
                className="fw-400 fs-18"
                style={{
                  color:
                    viewData?.roomsAndRates?.refundability === "Refundable"
                      ? "#28a745"
                      : "#dc3545",
                }}
              >
                {" "}
                {viewData?.roomsAndRates?.refundability}
              </span>
            </p>
            {viewData?.roomsAndRates &&
              viewData?.roomsAndRates?.cancellationPolicies &&
              viewData?.roomsAndRates?.cancellationPolicies[0]?.rules &&
              viewData?.roomsAndRates.cancellationPolicies[0]?.rules.length !==
                0 &&
              viewData?.roomsAndRates?.refundability.toLowerCase() ===
                "refundable" && (
                <div>
                  <p className="fs-16 fw-600">Cancellation Policy</p>

                  <p className="fs-12">
                    •{" "}
                    {viewData?.roomsAndRates.cancellationPolicies[0]?.rules[0]
                      .value === 0
                      ? "No cancellation fee "
                      : ` A cancellation fee of  ${
                          viewData?.roomsAndRates.cancellationPolicies[0]
                            ?.rules[0].valueType === "Percentage"
                            ? `${viewData?.roomsAndRates?.cancellationPolicies[0]?.rules[0].value}% of the total amount`
                            : `$${viewData?.roomsAndRates?.cancellationPolicies[0]?.rules[0].value.toFixed(
                                2
                              )}`
                        }`}{" "}
                    will be charged if you cancel between{" "}
                    {
                      viewData?.roomsAndRates.cancellationPolicies[0]?.rules[0].start.split(
                        "T"
                      )[0]
                    }{" "}
                    {viewData?.roomsAndRates?.cancellationPolicies[0]?.rules[0].start
                      .split("T")[1]
                      .split(":")
                      .slice(0, 2)
                      .join(":")}{" "}
                    and{" "}
                    {
                      viewData?.roomsAndRates.cancellationPolicies[0]?.rules[0].end.split(
                        "T"
                      )[0]
                    }{" "}
                    {viewData?.roomsAndRates?.cancellationPolicies[0]?.rules[0].end
                      .split("T")[1]
                      .split(":")
                      .slice(0, 2)
                      .join(":")}
                  </p>
                  <p className="fs-12">
                    •{" "}
                    {viewData?.roomsAndRates?.cancellationPolicies[0]?.rules[
                      viewData?.roomsAndRates.cancellationPolicies[0]?.rules
                        .length - 1
                    ].value === 0
                      ? "No cancellation fee "
                      : ` 100% cancellation fee of  `}{" "}
                    will be charged if you cancel after{" "}
                    {
                      viewData?.roomsAndRates?.cancellationPolicies[0]?.rules[0].end.split(
                        "T"
                      )[0]
                    }{" "}
                    {viewData?.roomsAndRates?.cancellationPolicies[0]?.rules[0].end
                      .split("T")[1]
                      .split(":")
                      .slice(0, 2)
                      .join(":")}
                  </p>
                </div>
              )}
            {viewData?.taxresult?.tax_breakdown[0]?.amount !== 0 && (
              <>
                <p className="fs-16 fw-600 mb-4">
                  Taxes :
                  <span className="fw-400 fs-18">
                    {" "}
                    $ {viewData?.taxresult?.tax_breakdown[0]?.amount / 100}
                  </span>
                </p>
                <p className="fs-16 fw-600 mb-4">
                  SubTotal:
                  <span className="fw-400 fs-18">
                    {" "}
                    ${" "}
                    {viewData?.taxresult?.tax_breakdown[0]?.taxable_amount /
                      100}
                  </span>
                </p>
              </>
            )}
            <p className="fs-16 fw-600 mb-4">
              Total Amount :
              <span className="fw-400 fs-18">
                {" "}
                $ {viewData?.taxresult?.amount_total / 100}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>Sevenly-Arrival</title>
        <meta name="description" content="Arrival Management System" />
      </Helmet>

      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-2">
        <h2>Arrival Management</h2>
      </div>

      <MUIDataTable
        title="Arrival List Management"
        data={allArrivals}
        columns={columns}
        options={options}
      />

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={dialogState.open}
        maxWidth="xl"
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>Details</h3>
          <IconButton onClick={handleClose} aria-label="Close dialog">
            <Close />
          </IconButton>
        </div>

        <DialogContent dividers>{renderDetailView()}</DialogContent>

        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ArrivalsList;
